import { UploadCloud } from "lucide-react";

export default function UploadDropzone({

    dragging = false,

    accept = "*",

    title = "Drag & Drop files here",

    subtitle = "or click to browse your computer",

    supportedText = "Supports images, videos, documents, PDFs, ZIP files and more.",

    onDragOver,

    onDragLeave,

    onDrop,

    onSelect

}){

    return(

        <label

            className={`upload-area ${
                dragging
                    ? "dragging"
                    : ""
            }`}

            onDragOver={onDragOver}

            onDragLeave={onDragLeave}

            onDrop={onDrop}

        >

            <input

                hidden

                type="file"

                accept={accept}

                onChange={e=>

                    onSelect?.(
                        e.target.files
                    )

                }

            />

            <div className="upload-icon">

                <UploadCloud

                    size={56}

                    strokeWidth={1.7}

                />

            </div>

            <div className="upload-title">

                {title}

            </div>

            <div className="upload-subtitle">

                {subtitle}

            </div>

            <div className="upload-supported">

                {supportedText}

            </div>
<style>{`.upload-area{

    border:2px dashed #CBD5E1;

    border-radius:20px;

    padding:60px 24px;

    background:#FAFBFC;

    display:flex;

    flex-direction:column;

    align-items:center;

    justify-content:center;

    text-align:center;

    cursor:pointer;

    transition:all .25s ease;

}

.upload-area:hover{

    border-color:#2563EB;

    background:#EFF6FF;

}

.upload-area.dragging{

    border-color:#2563EB;

    background:#EFF6FF;

    transform:scale(1.01);

}

.upload-icon{

    width:76px;

    height:76px;

    border-radius:18px;

    display:flex;

    justify-content:center;

    align-items:center;

    margin-bottom:18px;

    background:#EEF4FF;

    color:#2563EB;

}

.upload-title{

    font-size:20px;

    font-weight:700;

    color:#0F172A;

}

.upload-subtitle{

    margin-top:8px;

    color:#64748B;

    font-size:15px;

}

.upload-supported{

    margin-top:16px;

    max-width:420px;

    color:#94A3B8;

    font-size:13px;

    line-height:1.6;

}`}</style>
        </label>

    );

}